export default "__VITE_ASSET__CRGO2ZM4__"